import { render } from "./flat2.vue?vue&type=template&id=d29436fc"
import script from "./flat2.vue?vue&type=script&lang=js"
export * from "./flat2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__